import { ethers } from 'ethers';

/**
 * number 타입을 0x가 포함된 hex string으로 변환
 * @param num 변환할 number
 * @returns hex string
 */
export function number2hex(num: number): string {
  const hex = `0x${num.toString(16)}`;
  return hex.toLowerCase();
}

/**
 * ethers 라이브러리의 sha256 알고리즘 함수
 * @param data 해싱할 데이터
 * @returns hash
 */
export function sha256(data: ethers.utils.BytesLike) {
  const hash = ethers.utils.sha256(data);
  return hash;
}

export function formatTokenAmount(amount: string | null): string {
  return amount
    ? Math.floor(Number(amount))
        ?.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, `,`)
    : `0`;
}

export const convertToExactAddress = (address: string) =>
  ethers.utils.getAddress(address.toLowerCase());
